// @owners { team: patients-team }
import { SHIPMENT_STATUS_MAP } from '~shared/features/shipments/constants';

export const useShipmentStatusMap = () => {
  return SHIPMENT_STATUS_MAP;
};
